<template>
  <el-dialog ref="dialog" title="新建内容" @close="_onClose" v-model="dialogVisible">
    <el-form label-width="100px" :rules="rules" :model="content" ref="dialogForm">
      <el-form-item label="类型">
        <el-radio v-model="content.type" :label="2" :disabled="!!content.id">图文</el-radio>
        <el-radio v-model="content.type" :label="1" :disabled="!!content.id">H5</el-radio>
        <el-radio v-model="content.type" :label="3" :disabled="!!content.id">链接</el-radio>
      </el-form-item>
      <el-form-item label="分类" prop="categoryId">
        <el-col :span="12">
          <el-select v-model="content.categoryId" placeholder="请选择">
            <el-option v-for="item in categoryList" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="content.title" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="链接" v-if="content.type == 3" prop="originalLink">
        <el-input v-model="content.originalLink" placeholder="http://"></el-input>
      </el-form-item>
      <el-form-item label="上传图片" v-if="content.type == 3">
        <el-col :span="12">
          <el-upload
            name="Filedata"
            :action="uploadUrl"
            :before-upload="beforeUpload"
            :file-list="fileList"
            :show-file-list="show_file_list"
            :on-success="success"
            :on-error="error">
            <el-button size="small" :loading="loading" type="primary">点击上传</el-button>
          </el-upload>
        </el-col>
      </el-form-item>
      <el-form-item label="摘要" prop="describe">
        <el-input type="textarea" :rows="2" v-model="content.describe"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import _ from 'lodash'
  import products from 'api/products'
  import categories from 'api/categories'

  export default {
    data: () => ({
      dialogVisible: false,
      content: {
        id: 0,
        uuid: '',
        title: '',
        categoryId: null,
        type: 2,
        iconPath: '',
        iconGroup: '',
        originalLink: ''
      },
      categoryList: [],
      rules: {
        'title': [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        'categoryId': [
          { type: 'number', required: true, message: '请选择分类', trigger: 'blur' }
        ],
        'originalLink': [
          { required: true, message: '请输入链接', trigger: 'blur' }
        ],
        'iconPath': [
          { required: true, message: '请上传图片', trigger: 'blur' }
        ]
      },
      // 上传图片列表
      fileList: [],
      show_file_list: false,
      loading: false
    }),
    computed: {
      uploadUrl () {
        return this.$dm.get() + '/basedata/file/uploadimg'
      }
    },
    mounted () {
      this.loadCategory()
    },

    methods: {
      /**
       * 保存
       */
      save () {
        this.$refs.dialogForm.validate((val) => {
          if (!val) return console.error('验证错误！')
          // 判断是否为新增
          if (!this.content.id) {
            products.save(this.content).then(res => {
              if (res.body.code !== 2000) throw new Error(res.body.msg)
              if (this.content.type === 3) {
                this.close()
                return this.$message('添加成功')
              }
              location.assign('/contents/edit/' + res.body.data.id)
            }).catch(err => {
              console.error(err)
            })
          } else {
            products.update(this.content).then(res => {
              if (res.body.code !== 2000) throw new Error(res.body.msg)
              this.close()
              return this.$message('更新成功')
            }).catch(err => {
              console.error(err)
            })
          }
        })
      },

       /**
       * 分类列表渲染
       */
      loadCategory (data) {
        return categories.get().then(res => {
          this.categoryList = res.body.data
        })
      },

      /**
       * 打开
       */
      open (content) {
        this.dialogVisible = true
        if (content && content.id) {
          _.extend(this.content, {
            id: content.id,
            uuid: content.uuid,
            title: content.title,
            categoryId: content.categoryId,
            describe: content.describe,
            type: content.type,
            iconPath: content.iconPath,
            iconGroup: content.iconGroup,
            originalLink: content.originalLink
          })
        }
      },

      /**
       * 关闭
       */
      close () {
        this.dialogVisible = false
      },

      _onClose () {
        this.reset()
        this.$emit('close')
      },

      /**
       * 重置
       */
      reset () {
        _.extend(this.$data, {
          content: {
            id: 0,
            title: '',
            categoryId: null,
            describe: '',
            type: 2,
            iconPath: '',
            iconGroup: '',
            originalLink: ''
          }
        })
      },

      /**
      * 图片上传
      */
      success (res, file, fileList) {
        this.content.iconPath = res.data.icon.filename
        this.content.iconGroup = res.data.middle.filename
        var list = {name: file.name, url: file.url, tatus: 'finished'}
        this.fileList = [list]
        this.loading = false
        this.show_file_list = true
      },
      error () {
        this.loading = false
        this.$message.error('上传图片失败')
      },
      beforeUpload () {
        this.show_file_list = false
        this.loading = true
      }
    }
  }
</script>

<style>
  
</style>



// WEBPACK FOOTER //
// newContentDialog.vue?5b517f32